import React from "react";
import Icon from "../atoms/Icon";

export default () =>
    <div className="m-wave-divider">
        <Icon iconName={ 'icon-wave' } className={ "m-wave-divider__icon a-icon a-icon--xl" }/>
        <Icon iconName={ 'icon-waves' } className={ "m-wave-divider__icon a-icon a-icon--xl" }/>
    </div>;